import React, { useState } from "react";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import { FormControl, IconButton, InputAdornment } from "@mui/material";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { actions as appActions } from "../../../app/appSlice";
import { useEditAdminPasswordMutation } from "../../api/admin/adminAccount";
import { useEditPasswordMutation } from "../../api/user/userAccount";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { ROLE } from "../../../utils/constants/profiles";
import { t } from "i18next";

const ModificaPasswordPage = ({ cardElement }) => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state.app.role);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    passwordAttuale: "",
    nuovaPassword: "",
    confermaNuovaPassword: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    passwordAttuale: "",
    nuovaPassword: "",
    confermaNuovaPassword: "",
    general: "",
  });
  const [editAdminPassword, { isLoading: isEditingPassword }] =
    useEditAdminPasswordMutation();

  const [editUserPassword, { isLoading: isEditingUserPassword }] =
    useEditPasswordMutation();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setValidationErrors({ ...validationErrors, [name]: "" });
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const handleClickShowCurrentPassword = () =>
    setShowCurrentPassword(!showCurrentPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!formData.passwordAttuale) errors.passwordAttuale = t("FieldRequired");
    if (!formData.nuovaPassword) errors.nuovaPassword = t("FieldRequired");
    if (!formData.confermaNuovaPassword)
      errors.confermaNuovaPassword = t("FieldRequired");
    if (formData.nuovaPassword !== formData.confermaNuovaPassword)
      errors.confermaNuovaPassword = t("PasswordMismatch");
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    setValidationErrors({});
    const id = toast.loading(t("Saving..."), {
      type: "info",
    });
    const passwordData = {
      NewPassword: formData.nuovaPassword,
      Password: formData.passwordAttuale,
    };
    (role === ROLE.USER
      ? editUserPassword(passwordData)
      : editAdminPassword(passwordData)
    )
      .then((res) => {
        setFormData({
          passwordAttuale: "",
          nuovaPassword: "",
          confermaNuovaPassword: "",
        });
        if (res.data?.Result !== 1) {
          toast.update(id, {
            render: res.data?.Exception || t("ReqErr"),
            type: "error",
            autoClose: 1500,
            isLoading: false,
          });
          return;
        }
        toast.update(id, {
          render: t("PasswordUpdated"),
          type: "success",
          autoClose: 1500,
          isLoading: false,
        });
        dispatch(
          appActions.setRstPasswordRequired({
            Data: { rstPasswordRequired: false },
          })
        );
      })
      .catch(() =>
        toast.update(id, {
          render: t("ReqErr"),
          type: "error",
          autoClose: 1500,
          isLoading: false,
        })
      );
  };

  return (
    <div>
      <div className="flex flex-col items-center">
        {!cardElement && <h2>{t("EditPassword")}</h2>}
        <FormControl
          sx={{ width: "80%" }}
          onSubmit={handleSubmit}
          className={`flex flex-col ${cardElement ? "" : "mt-6"}`}
        >
          <CoreInputField
            label={t("CurrentPassword")}
            type={showCurrentPassword ? "text" : "password"}
            name="passwordAttuale"
            value={formData.passwordAttuale}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.passwordAttuale)}
            helperText={validationErrors.passwordAttuale}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowCurrentPassword}>
                    {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <CoreInputField
            sx={{ marginTop: cardElement ? "7px" : "30px" }}
            label={t("NewPassword")}
            type={showPassword ? "text" : "password"}
            name="nuovaPassword"
            value={formData.nuovaPassword}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.nuovaPassword)}
            helperText={validationErrors.nuovaPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <CoreInputField
            sx={{ marginTop: cardElement ? "7px" : "30px" }}
            label={t("ConfirmNewPassword")}
            type={showConfirmPassword ? "text" : "password"}
            name="confermaNuovaPassword"
            value={formData.confermaNuovaPassword}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.confermaNuovaPassword)}
            helperText={validationErrors.confermaNuovaPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowConfirmPassword}>
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <div
            className={`flex justify-around ${cardElement ? "mt-7" : "mt-12"}`}
          >
            <CoreButton
              disabled={isEditingPassword || isEditingUserPassword}
              sx={{ width: "150px", textAlign: "center" }}
              className={"btn-round"}
              variant="contained"
              testo={
                isEditingPassword || isEditingUserPassword
                  ? t("Wait")
                  : t("Edit")
              }
              onClick={handleSubmit}
            />
          </div>
        </FormControl>
      </div>
    </div>
  );
};

export default ModificaPasswordPage;
